<form [formGroup]="formGroup" (submit)="isFormValid()" fxLayout="column" fxLayoutAlign="center center">

  <mat-toolbar fxLayout="row">
    <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="confirmChanges()" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{ detail?.id ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_WEB_USER' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_WEB_USER' | translate }) }}
    </span>
    <span fxFlex></span>
    <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]="disableSaveBtn()">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  </mat-toolbar>

  <div fxLayout="column" class="padding-25" fxFlexFill style="position: relative;">
    <div *ngIf="loading.init" fxFlex fxLayout="column" fxLayoutAlign="center center" class="loading-overlay">
      <mat-spinner></mat-spinner>
    </div>

    <!-- username -->
    <div fxLayout>
      <mat-form-field>
        <input
          #username
          matInput
          required
          autocomplete="off" 
          formControlName="username" 
          [placeholder]="'LABEL_USERNAME' | translate"
          >

        <mat-error *ngIf="formGroup.get('username').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error> 

        <mat-error *ngIf="formGroup.get('username').hasError('minlength')">
          {{ 'MSG_MINLENGTH' | translate: {length: '8'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('username').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '16'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('username').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- fullname -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #fullname 
          autocomplete="off" 
          formControlName="fullname" 
          [placeholder]="'LABEL_FULL_NAME' | translate"
          >

        <mat-error *ngIf="formGroup.get('fullname').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('fullname').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '250'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('fullname').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- email_address -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #email_address 
          autocomplete="off" 
          formControlName="email_address" 
          [placeholder]="'LABEL_EMAIL_ADDRESS' | translate"
          >

        <mat-error *ngIf="formGroup.get('email_address').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('email_address').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '250'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('email_address').hasError('pattern')">
          {{ 'MSG_ERROR_INVALID_EMAIL_FORMAT' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- role -->
    <esc-role-dropdown
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="roleSelected($event)"
      [previousData]="detail"
      [requiredError]="roleRequired"
      >
    </esc-role-dropdown>

    <!-- company -->
    <mat-form-field class="width-100">
      <mat-chip-list #chipsCompany aria-label="Company" [disabled]="!isGlobalSchema">
        <mat-chip *ngFor="let data of multiSelect.selectedCompanies" [removable]="true"
          (removed)="toggleSelection(
                data,
                filterOptions.company,
                'selectedCompanies',
                'company',
                companyInput
              )">
          {{ data.description }}
          <mat-icon matChipRemove aria-hidden="false" aria-label="remove">cancel</mat-icon>
        </mat-chip>
    
        <input matInput #companyInput [matChipInputFor]="chipsCompany" formControlName="company"
          [matChipInputAddOnBlur]="true" [matAutocomplete]="companyAC" (focus)="getInitialData('company')"
          (blur)="
            checkAutocompleteObject(
              formGroup,
              'company',
              'selectedCompanies'
            )"
          [disabled]="formGroup.get('company').disabled"
          [placeholder]="'LABEL_COMPANY' | translate" />
    
        <mat-icon matSuffix svgIcon="menu-down" *ngIf="!companyInput.value"
          class="autocomplete-arrow-color cursor-pointer" (click)="companyInput.focus()">
        </mat-icon>
      </mat-chip-list>
    
      <mat-autocomplete [displayWith]="displayFn" #companyAC="matAutocomplete"
        (opened)="autocompleteScroll('company', 'companyACRef', 'companyACTr')">
        
        <mat-option disabled *ngIf="!loading.company && filterOptions.company?.length == 0">
          {{ 'MSG_NO_DATA' | translate }}
        </mat-option>
    
        <ng-container>
          <mat-option *ngFor="let data of filterOptions.company" [value]="data" [disabled]="data.disabled">
            <div (click)="
              !data.disabled &&
              optionClicked(
                $event,
                data,
                filterOptions.company,
                'selectedCompanies',
                'company',
                companyInput
              )
            " [class.disable]="data.disabled">
              <mat-checkbox [checked]="data.selected" (change)="
                toggleSelection(
                  data,
                  filterOptions.company,
                  'selectedCompanies',
                  'company',
                  companyInput
                )
              " (click)="$event.stopPropagation()" [disabled]="data.disabled">
                {{ data.description }}
              </mat-checkbox>
            </div>
          </mat-option>
        </ng-container>
    
        <mat-option *ngIf="loading.company" disabled>
          <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate"
            [diameter]="45"></mat-spinner>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    
    <!-- status / is_active -->
    <mat-checkbox formControlName="status">Active</mat-checkbox>

  </div>
</form>